import { Injectable, Inject } from "@angular/core";
import { AppConfig } from "src/environments/appconfig";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { ParametrosmastPk, Parametrosmast } from "../dominio/Parametrosmast";
import { UHttpsClient } from "../../../../seguridad/seguridad/uhttpsClient";

@Injectable()
export class ParametrosmastServicio {

    private url = `${this.config.getEnv('proxy')}spring/core/parametrosmast/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public obtenerPorId(pk: ParametrosmastPk): Promise<Parametrosmast> {
        return this.http.post(`${this.url}obtenerPorId`, pk,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as Parametrosmast;
            })
            .catch(error => new Parametrosmast());
    }
}

